import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { OnboardingService } from './onboarding.service';
import { inject } from '@angular/core';
import { ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, filter, from, map, of, switchMap, take, tap } from 'rxjs';
import { BsCacheService, BsHubService } from '@brightside-web/desktop/data-access/core-services';
import { isLoginLegalDocsPath } from '@brightside-web/shared/desktop';


// this guard should only block navigation if onboarding is NOT complete
// is this even necessary? onboarding guard should handle everything

export const onboardingCompleteGuard: CanActivateFn = () => checkOnboardingComplete();

export const onboardingMatchCompleteGuard: CanMatchFn = (_route, segments) => {
  // Login legal documents are presented at /home/legal and must not be preempted by the
  // onboarding redirect — terms come immediately after sign-in, before onboarding.
  if (isLoginLegalDocsPath(segments)) {
    return of(true);
  }
  return checkOnboardingComplete();
}

export const onboardingCompleteCanActivateGuard: CanActivateFn = () => checkOnboardingComplete();

function checkOnboardingComplete() {
  const _onboardingService = inject(OnboardingService);
  const _bsHubService = inject(BsHubService);
  const _bsCacheService = inject(BsCacheService);
  const router = inject(Router);

  return combineLatest([
    toObservable(_onboardingService.state),
    toObservable(_onboardingService.error),
  ]).pipe(
    tap(([state, error]) => {
      if (state === null && error) {
        _onboardingService.somethingWentWrong();
      }
    }),
    filter((result): result is [ServiceState, string | undefined] => result[0] !== null),
    take(1),
    switchMap(([state]) =>
      from(_bsCacheService.getItem('ONBOARDING_COMPLETE')).pipe(
        map(complete => {
          if (complete) {
            _bsCacheService.removeItem('ONBOARDING_FLOW_ACTIVE');
            _bsHubService.dispatch('OnboardingChannel', { event: 'OnboardingComplete', message: 'cleared guard' });
            return true;
          } else {
            if (state === ServiceState.INITIAL || state === ServiceState.PENDING) {
              return router.parseUrl('/onboarding');
            }
            _bsCacheService.removeItem('ONBOARDING_FLOW_ACTIVE');
            _bsHubService.dispatch('OnboardingChannel', { event: 'OnboardingComplete', message: 'cleared guard' });
            return true;
          }
        })
      )
    )
  );
}
